import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_EE.json';
import audios from './ASTROLOGY_AUDIOS_EE.json';

export const ASTROLOGY_DATA_EE: ServiceData = {
  articles,
  audios,
};
